export default "__VITE_ASSET__BMvMVRuh__"